"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.protectedEstimateLoRaAirtime = exports.estimateLoRaAirtime = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const TypeHelpers_1 = require("../TypeHelpers");
const codeRateMap = {
    '4/5': 1,
    '4/6': 2,
    '4/7': 3,
    '4/8': 4,
};
/** return estimated airtime in millisconds */
const estimateLoRaAirtime = ({ payloadBytes, sf, bw, codeRate, preambleLength = 8, adr = false, explicitHeader = true, }) => {
    /** protection against bw scale */
    if (Math.floor(bw / 1000) === 0) {
        bw = bw * 1000;
    }
    const cr = codeRateMap[codeRate];
    if (cr) {
        // Symbol time (ms)
        const Tsym = (2 ** sf / bw) * 1000;
        // Preamble duration (ms)
        const Tpreamble = (preambleLength + 4.25) * Tsym;
        // Payload symbol calculation
        const H = explicitHeader ? 0 : 1;
        const DE = adr ? 1 : 0;
        const payloadSymb = 8 + Math.max(Math.ceil((8 * payloadBytes - 4 * sf + 28 + 16 - 20 * H) / (4 * (sf - 2 * DE))) * (cr + 4), 0);
        // Payload duration (ms)
        const Tpayload = payloadSymb * Tsym;
        // Total time on air (ms)
        return Tpreamble + Tpayload;
    }
    else {
        return undefined;
    }
};
exports.estimateLoRaAirtime = estimateLoRaAirtime;
const protectedEstimateLoRaAirtime = ({ adr, bw, sf, codeRate, payloadStr }) => {
    const res = { err: null, data: null };
    if ((0, iotv_v3_types_1.isNonNaNNumber)(sf) && (0, iotv_v3_types_1.isNonNaNNumber)(bw) && !!codeRate && !!payloadStr) {
        const payloadBytes = Math.floor(payloadStr.length / 2);
        const airtime = (0, exports.estimateLoRaAirtime)({ sf, bw, codeRate, payloadBytes, adr: adr ?? false, explicitHeader: true });
        if ((0, iotv_v3_types_1.isNonNaNNumber)(airtime)) {
            const sanitizedAirtime = (0, TypeHelpers_1.roundDecimals)(airtime / iotv_v3_types_1.Milliseconds.SECOND, 3);
            res.data = sanitizedAirtime;
        }
        else {
            res.err = new Error(`${airtime} not non null number`);
        }
    }
    else {
        res.err = new Error(`Something not non null number, ${JSON.stringify({ sf, bw, })}`);
    }
    return res;
};
exports.protectedEstimateLoRaAirtime = protectedEstimateLoRaAirtime;
